<style lang="scss" scoped>
@import '@/view/qwAuth/index.scss';
.btnBar {
  .line {
    width: 1px;
    height: 250px;
    background: #eeeeee;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .toLoginTop {
    z-index: 99;
  }
  .block {
    width: 444px;
    height: 426px;
    background: #ffffff;
    border-radius: 2px;
    text-align: center;
    padding-top: 73px;
    position: relative;

    .title {
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1890ff;
      line-height: 28px;
      margin-bottom: 8px;
    }
    .desc {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #555555;
      line-height: 20px;
      margin-bottom: 19px;
    }
    .image {
      width: 162px;
      height: 152px;
      display: block;
      margin: auto;
      margin-bottom: 41px;
    }
    .btn {
      width: 200px;
      height: 40px;
      background: #1890ff;
      border-radius: 2px;
    }
    &:hover {
      z-index: 1;
      box-shadow: 0px 12px 42px 0px rgba(0, 0, 0, 0.14);
    }
  }
}
</style>
<template>
  <div
    class="view-flex btnBar"
    style="position: relative"
  >
    <div
      class="toLogin toLoginTop"
      @click="$router.push({ path: '/auth/login' })"
    >
      已有账号 <span class="toLogin_btn">直接登录</span>
    </div>
    <div class="block">
      <div>
        <h3 class="title">
          还没有企业微信
        </h3>
        <p class="desc">
          5分钟立即注册带有企微管家的企业微信
        </p>
        <img
          class="image"
          :src="require('@/assets/img/qwLogin/loginLeft.png')"
          alt=""
        >
        <div
          class="qwBtn"
          @click="$parent.dialogVisible = true"
        >
          <img
            :src="require('@/assets/img/qwLogin/qwImg/register_blue.png')"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="line" />

    <div class="block">
      <div>
        <slot
          class="toLogin"
          name="toLogin"
        />
        <h3 class="title">
          已经有企业微信
        </h3>
        <p class="desc">
          30秒安装企微管家到企业微信
        </p>
        <img
          class="image"
          :src="require('@/assets/img/qwLogin/loginRight.png')"
          alt=""
        >
        <div
          class="qwBtn"
          @click="$parent.dialogVisible2 = true"
        >
          <img
            :src="require('@/assets/img/qwLogin/qwImg/install_white_middle.png')"
            alt=""
          >
        </div>

        <!-- <div class="qwBtn">
          <el-button
            type="primary"
            plain
            class="btn"
            style="
              margin-right: 0;
              border: 1px solid #2083e0;
              background-color: #fff;
              color: #2083e0;
            "
            @click="$router.push({path:'/qwAuth/login'})"
          >
            账号密码登录
          </el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'QwIndexBlock',

  data () {
    return {}
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>
